module.exports = __webpack_public_path__ + "media/images/favicons/favicon-77914f248bf06a89bba71225531378a7.png";